import { render, staticRenderFns } from "./gj-text.vue?vue&type=template&id=4ac1845a&scoped=true&"
import script from "./gj-text.vue?vue&type=script&lang=js&"
export * from "./gj-text.vue?vue&type=script&lang=js&"
import style0 from "./gj-text.vue?vue&type=style&index=0&id=4ac1845a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ac1845a",
  null
  
)

export default component.exports